import qs from 'qs';
import React, { useContext } from 'react';
import { Query } from 'react-apollo';
import SortOrderContainer from '../SortOrder/SortOrderContainer';
import CategoryRoute from './CategoryRoute';
import ProductRoute from './ProductRoute';
import ContentRoute from './ContentRoute';
import PaginationContext from '../Pagination/PaginationContext';
import throwErrorInDev from '../../helpers/throwErrorInDev';
import { PreviewContext } from '../PreviewContext';
import ChannelContext from '../ChannelContext';
const PreviewRoute = ({ productPage, categoryPage, contentPage, productQuery, categoryQuery, pageQuery, location, StartPage }) => {
    const { setPreview } = useContext(PreviewContext);
    const { setCultureForPreview, restoreCultureForPreview } = useContext(ChannelContext);
    throwErrorInDev(!productQuery, `You forgot to pass 'productQuery' to PreviewRoute`);
    throwErrorInDev(!categoryQuery, `You forgot to pass 'categoryQuery' to PreviewRoute`);
    throwErrorInDev(!pageQuery, `You forgot to pass 'pageQuery' to PreviewRoute`);
    const { search } = location;
    const queryObject = qs.parse(search, {
        ignoreQueryPrefix: true
    });
    const { articlenumber, startpageid, categoryid, pageid, culture } = queryObject;
    setPreview(true);
    if (culture) {
        setCultureForPreview(culture);
    }
    if (articlenumber) {
        return (React.createElement(Query, { onCompleted: () => {
                setPreview(false);
                if (culture) {
                    restoreCultureForPreview();
                }
            }, query: productQuery, variables: {
                articleNumber: articlenumber
            } }, (result) => (React.createElement(ProductRoute, { result: result, component: productPage }))));
    }
    else if (categoryid) {
        return (React.createElement(PaginationContext.Consumer, null, ({ offset, perPage }) => (React.createElement(SortOrderContainer, null, ({ sortOrder, direction }) => (React.createElement(Query, { onCompleted: () => setPreview(false), query: categoryQuery, variables: {
                id: parseInt(categoryid, 10),
                orderBy: sortOrder,
                orderByDirection: direction,
                offset,
                first: perPage
            } }, (result) => (React.createElement(CategoryRoute, { result: result, component: categoryPage }))))))));
    }
    else if (pageid) {
        return (React.createElement(Query, { onCompleted: () => setPreview(false), query: pageQuery, variables: {
                id: parseInt(pageid, 10)
            } }, (result) => (React.createElement(ContentRoute, { result: result, component: contentPage }))));
    }
    else if (startpageid) {
        return (React.createElement(StartPage, { startPageId: parseInt(startpageid, 10), location: location }));
    }
    else
        return null;
};
export default PreviewRoute;
//# sourceMappingURL=PreviewRoute.js.map